import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

// Pages
import LoginPage       from './pages/LoginPage';
import AcceptInvite    from './pages/AcceptInvite';
import DashboardPage   from './pages/DashboardPage';
import InventoryPage   from './pages/InventoryPage';
import CheckoutPage    from './pages/CheckoutPage';
import PullListsPage   from './pages/PullListsPage';
import JobSitesPage    from './pages/JobSitesPage';
import UsersPage       from './pages/UsersPage';
import NotificationsPage from './pages/NotificationsPage';
import SettingsPage    from './pages/SettingsPage';
import TutorialPage    from './pages/TutorialPage';
import LabelsPage      from './pages/LabelsPage';

function PrivateRoute({ children, minRole }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen text-gray-500">Loading...</div>;
  if (!user)   return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login"          element={<LoginPage />} />
      <Route path="/accept-invite"  element={<AcceptInvite />} />
      <Route path="/tutorial"       element={<PrivateRoute><TutorialPage /></PrivateRoute>} />
      <Route path="/dashboard"      element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
      <Route path="/inventory"      element={<PrivateRoute><InventoryPage /></PrivateRoute>} />
      <Route path="/inventory/labels" element={<PrivateRoute><LabelsPage /></PrivateRoute>} />
      <Route path="/checkout"       element={<PrivateRoute><CheckoutPage /></PrivateRoute>} />
      <Route path="/pull-lists"     element={<PrivateRoute><PullListsPage /></PrivateRoute>} />
      <Route path="/job-sites"      element={<PrivateRoute><JobSitesPage /></PrivateRoute>} />
      <Route path="/users"          element={<PrivateRoute minRole="warehouse_manager"><UsersPage /></PrivateRoute>} />
      <Route path="/notifications"  element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />
      <Route path="/settings"       element={<PrivateRoute minRole="general_manager"><SettingsPage /></PrivateRoute>} />
      <Route path="/"               element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/warehouseinventory">
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
